// extracted by mini-css-extract-plugin
module.exports = {"root":"certifications_root__3tIIG","list":"certifications_list__2nZXQ","head":"certifications_head__3hMgT","item":"certifications_item__3fkiV"};